import {
  useValidationContext,
  useFormContext,
} from "@tandemdiabetes/sugarmate-react-components"
import type { RefObject } from "react"
import { useEffect } from "react"

interface Props {
  // when this value changes it will retrigger validation
  dependency: string;
  // this callback should update any custom errors
  updateCustomErrorCallback: (value: string) => void;
  // a reference to the input
  inputRef: RefObject<HTMLInputElement | null>;
}

/*
 * this component can update the form validity state and the state of any
 * validation messages whenever the value of "dependency" changes
 *
 * this is helpful when applying custom error messages to inputs that need to
 * be reevaluated even when the value of the input has not changed
 */
export function RetriggerValidation(props: Props) {
  const {
    updateCustomErrorCallback,
    inputRef,
    dependency,
  } = props

  const formContext = useFormContext()
  const recheckValidity = formContext?.recheckValidity

  const context = useValidationContext()
  const updateValidityState = context?.updateValidityState

  useEffect(
    () => {
      if (inputRef.current) {
        updateCustomErrorCallback(inputRef.current.value)
        recheckValidity?.()
        updateValidityState?.(inputRef.current)
      }
    },
    [
      updateCustomErrorCallback,
      dependency,
      inputRef,
      updateValidityState,
      recheckValidity,
    ],
  )

  return null
}
